export function upsertTask(items, task) {
  const index = items.findIndex((candidate) => candidate.id === task.id);
  if (index >= 0 && Number(items[index].version ?? 0) >= Number(task.version ?? 0)) {
    return items;
  }
  if (index < 0) return [...items, task];

  const next = [...items];
  next.splice(index, 1, task);
  return next;
}

export function removeTask(items, id, version) {
  const current = items.find((task) => task.id === Number(id));
  if (current && Number(current.version ?? 0) > Number(version ?? 0)) return items;
  return items.filter((task) => task.id !== Number(id));
}

export function acceptEvent(seenEventIds, eventId) {
  if (!eventId) return true;
  if (seenEventIds.includes(eventId)) return false;
  seenEventIds.push(eventId);
  if (seenEventIds.length > 500) seenEventIds.splice(0, seenEventIds.length - 500);
  return true;
}
